import React from 'react';
import {CardTitle, CardText} from 'reactstrap';
import renderExplanation from './Explanation';


const ReadTask = ({title, description, explanation, showCorrect}) => {
    return <>
        <CardTitle dangerouslySetInnerHTML={{ __html: title }} />
        <CardText dangerouslySetInnerHTML={{ __html: description }} />
        {(showCorrect && explanation)? renderExplanation(explanation) : undefined}
    </>
}

export default ReadTask;